// extracted by mini-css-extract-plugin
module.exports = {"mainBlock":"EditPlaceOriginal_mainBlock__1DSTG","buttonsWrapper":"EditPlaceOriginal_buttonsWrapper__2unPl"};